import { render } from "./ArticleAuthors.vue?vue&type=template&id=56dab3f7"
import script from "./ArticleAuthors.vue?vue&type=script&lang=ts"
export * from "./ArticleAuthors.vue?vue&type=script&lang=ts"
script.render = render

export default script